import { MutableRefObject } from 'react';
import * as PIXI from "pixi.js"

import * as FBRConstants from '../FBRConstants';
import * as FBRTypes from '../FBRTypes';

const createInfoBar = (
	pixiAppRef: MutableRefObject<PIXI.Application | undefined>,
	globalState: MutableRefObject<FBRTypes.GlobalState>,
) => {
	const infoContainer = new PIXI.Container();
	const scoreText = new PIXI.Text(
		'SCORE ?????', 
		{ 
			fontFamily : 'Odibee Sans', 
			fontSize: 37, 
			fill : 0xffffff, 
			align : 'center' 
		}
	);
	const levelText = new PIXI.Text(
		'LEVEL ?????', 
		{ 
			fontFamily : 'Odibee Sans', 
			fontSize: 37, 
			fill : 0xffffff, 
			align : 'left' 
		}
	);
	scoreText.x = 25;
	scoreText.y = 25;
	levelText.anchor.set(1,0);
	levelText.x = pixiAppRef.current != null ? pixiAppRef.current.screen.width -25 : 250;
	levelText.y = 25;
	
	infoContainer.addChild(scoreText);
	infoContainer.addChild(levelText);

	const _update = () => {
		if(globalState.current.gameState == 'running') {
			scoreText.text = `SCORE ${ (globalState.current.score < 0 ? '-' : '') + String(Math.abs(globalState.current.score)).padStart(5,'0')}`;
			levelText.text = `LEVEL ${ String(globalState.current.level).padStart(5,'0')}`;
			infoContainer.visible = true;
		} else {
			infoContainer.visible = false;
		}
	}

	return {
		container: infoContainer,
		update: _update,
	};
};
	
export default createInfoBar;
